import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import {AdMessageService} from '@internal/common-ui/ad-message';

export type FileTypeValidator=(files:FileList)=>boolean|{isPass?:boolean,error?:string};

@Injectable({providedIn:'root'})
export class AdUploadService{
    constructor(
        private http:HttpClient,
        private adMessage:AdMessageService
    ){

    }

    _fileValidator:FileTypeValidator=(files:FileList)=>true;
    writeFileValidator(validator:FileTypeValidator){
        this._fileValidator=validator;
    }
    resetFileValidator(){
        this._fileValidator=()=>true;
    }

    validateFiles(files:FileList):boolean{
        if(this._fileValidator){
            let validateResult = this._fileValidator(files);
            if(typeof validateResult === 'boolean'){
                return validateResult;
            }else{
                if(validateResult.isPass==true){
                    return true;
                }else if(validateResult?.error?.length>0){
                    this.adMessage.confirm(
                        validateResult.error,
                        'Warning',
                        null,
                        null,
                        true,
                        'Confirm'
                    );                    
                }
                return false;
            }
        }
        return true;
    }

    uploadFiles(formData:FormData,url:string,method:string='post',showSpin?:boolean|'spin'){
        if(method=='post'){
            return this.http.post(url,formData,
                {
                    params:{
                        loading:''+showSpin
                    }
                });
        }
    }

    transformToFormData(files:FileList,name:string):FormData{
        let formData = new FormData();
        for(let i=0;i<files.length;i++){
            formData.append(name,files[i],files[i].name);
        }
        return formData;
    }

}